<template>
    <div class="blocProduit">
        <span v-if="isNewFormula" class="badge badge-primary">Nouvelle formule</span>
        <span v-if="isNew" class="badge badge-primary">Nouveauté</span>
        <span v-if="bestSales" class="badge badge-primary">Meilleures ventes</span>
        <span v-if="provenSatisfaction" class="badge badge-primary">Satisfaction prouvée</span>
        <span v-if="provenEffectiveness" class="badge badge-primary">Efficacité prouvée</span>
        <span v-if="isRecommended" class="badge badge-primary">Recommandé pour vous</span>

        <a @click="link" :href="url" class="vignette">
            <img :src="cardImage" :alt="title" class="img-fluid">
        </a>
        <h2>
            <a @click="link" :href="url">{{ title }} <span>{{ subtitle }}</span></a>
        </h2>

        <div class="zoneActions">
<!--          <a class="reviews NETREVIEWS_PRODUCT_STARS" :data-product-id=productId></a>-->
          <div class="reviews skeepers_product__stars"
               :data-product-id="productId">
          </div>

            <p class="prix">
                à partir de {{ lowestPrice | moneyFormat }}
                <del v-if="lowestBasePrice != lowestPrice">{{ lowestBasePrice | moneyFormat }}</del>
            </p>

            <a class="btn btn-default btnChoiceType" data-toggle="collapse" :href="'#layerChoiceType' + id" role="button" aria-expanded="false" :aria-controls="'layerChoiceType' + id" @click="closeOther()">Choisir une quantité</a>
            <div class="collapse layerChoiceType" :id="'layerChoiceType' + id">
                <div class="horizontalChoice">
                    <ponroy-product-reference-card
                            v-for="(reference, index) in references"
                            v-if="false == reference.direct_order"
                            v-model="orderable.id"
                            :key="reference.id"
                            :value="reference.id"
                            :reference="reference"
                            :radio-name="'radio-name-' + id"
                    >
                    </ponroy-product-reference-card>
                </div>
            </div>

            <button v-if="available" type="button" @click="update()" class="btn btn-primary hvr-grow">Ajouter au panier</button>
            <span v-else class="btn btn-primary btn-indispo">Indisponible</span>

        </div>
    </div>
</template>

<script>

    import {mapActions, mapState} from 'vuex';
    import store from '../store';

    export default {
        name: 'ponroy-product-card',
        store,
        data() {
            return {
                orderable: {
                    repository: this.repository,
                    id : this.references[0].id,
                },
                quantity: 1,
                productId: this.id,
            }
        },
        props: {
            id: String,
            title: String,
            subtitle: String,
            repository: String,
            isNewFormula: {
                type: Boolean,
                default: false
            },
            bestSales: {
                type: Boolean,
                default: false
            },
            isNew: {
                type: Boolean,
                default: false
            },
            provenSatisfaction: {
                type: Boolean,
                default: false
            },
            provenEffectiveness: {
                type: Boolean,
                default: false
            },
	        isRecommended: {
                type: Boolean,
                default: false
            },
            url: String,
            cardImage: String,
            shortDescription: String,
            references: Array,
            lowestPrice: Number,
            lowestBasePrice: Number,
            reviews: Array,
            reviewsAvg: Number,
            widgetId: {
                type: String,
                required: false,
            },
            available: {
                type: Boolean,
                default: true,
            }
        },
        methods: {
            ...mapActions('cart', [
                'addToCart',
            ]),
            ...mapActions('cart', {
                toggle : 'toggleWidget',
            }),
            update() {
                const {orderable, quantity} = this;

                let isOpen = $('#layerChoiceType' + this.id).hasClass('show');

                if (orderable.id && quantity && isOpen) {
                    this.addToCart({orderable, quantity});
                    this.toggle({isNotification: true});
                } else {
                    $('.blocProduit .collapse').collapse('hide');
                    $('#layerChoiceType' + this.id).collapse('show');
                }
            },
            closeOther() {
                $('.blocProduit .collapse').collapse('hide');
                $('#layerChoiceType' + this.id).collapse('show');
            },
            link(event) {
                event.preventDefault();
                if (true === this.isRecommended) {
                    // window._ebq = window._ebq || [];
                    // window._ebq.push(['trackActivity', {
                    //     original_id: this.id,
                    //     verb: 'click-on-reco',
                    //     type: 'product',
                    //     widgetId: '5b17a6a696438f51a4163a1a',
                    // }]);

                    window.location.href = this.url;
                } else {
                    window.location.href = this.url;
                }
            },
            starClass(avg, i) {
                let minus = avg - i + 1;
                return minus >= 1 ? "fa fa-star" : minus >= 0.5 ? "fa fa-star-half-o" : "fa fa-star-o";
            },
        },
        updated() {
            if (this.productId !== this.id) {
                this.orderable.id = this.references[0].id;
                this.productId = this.id;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/ProductCard.vue